import React from 'react';
import { useOrder } from '../../context/OrderContext';

const FixingSelector = ({ onSelect }) => {
  const { state } = useOrder();
  const { fixing } = state.orderDetails;

  const handleFixingSelect = (fixingType) => {
    onSelect({ fixing: fixingType });
  };

  return (
    <div className="text-center">
      <h2 className="text-xl font-bold mb-4">Seleziona il Tipo di Fissaggio</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {/* No fixing */}
        <button
          onClick={() => handleFixingSelect('')}
          className={`p-4 border rounded-lg ${fixing === '' ? 'bg-red-100 border-red-500' : 'border-gray-300'
            }`}
        >
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <span className="font-medium">Nessun Fissaggio</span>
          </div>
        </button>

        {/* Zinc-plated fixing */}
        <button
          onClick={() => handleFixingSelect('Z')}
          className={`p-4 border rounded-lg ${fixing === 'Z' ? 'bg-red-100 border-red-500' : 'border-gray-300'
            }`}
        >
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2 bg-gray-200 rounded-full">
              <span className="text-2xl font-bold">Z</span>
            </div>
            <span className="font-medium">Zincato</span>
          </div>
        </button>

        {/* Stainless steel fixing */}
        <button
          onClick={() => handleFixingSelect('X')}
          className={`p-4 border rounded-lg ${fixing === 'X' ? 'bg-red-100 border-red-500' : 'border-gray-300'
            }`}
        >
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2 bg-gray-300 rounded-full">
              <span className="text-2xl font-bold">X</span>
            </div>
            <span className="font-medium">Inox</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default FixingSelector;
